import { Route, Routes } from "react-router-dom";
import "./App.css";
import Home from "./pages/Home/Home";

import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";

import Contactus from "./pages/Contactus/Contactus";
import Blog from "./pages/Blog/Blog";
import Joinus from "./pages/Joinus/Joinus";
import BottomLink from "./components/BottomLink/BottomLink";
import Civil from "./pages/Civil/Civil";
import Interior from "./pages/Interior/Interior";
import Mpez from "./pages/Mpez/Mpez";
import Municipalityapproval from "./components/approvals/municipality-approval/Municipality-approval";
import Interioroutfit from "./pages/Interioroutfit/Interioroutfit";
import Civilinterior from "./pages/CivilInterior/Civilinterior";
import Mpezservice from "./pages/Mpezservices/Mpezservice";
import Multicommodities from "./components/approvals/multicommodities/Multicommodities";
import Roadandtransport from "./components/approvals/roadandtransport/roadandtransport";
import { HelmetProvider } from "react-helmet-async";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";




function App() {
  return (
    <div>
      
      <Header />
      <HelmetProvider>

      <ScrollToTop/>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contactus" element={<Contactus />} />
        {/* <Route path="/blog"  /> */}
        <Route path="/joinus" element={<Joinus />} />
       <Route path="/civil" element = {<Civil/>}/>
       <Route path="/interior" element = {<Interior/>}/>
       <Route path = "/mpez" element = {<Mpez/>}/>
       <Route path = "/approvals" element = {<Municipalityapproval/>}/>
       
       <Route path = "/interioroutfit" element = {<Interioroutfit/>}/>
       <Route path = "/civilinterior" element = {<Civilinterior/>}/>
       <Route path ='/mpezservice' element ={<Mpezservice/>}/>
       <Route path="/approval/municipality-approval" element = {<Municipalityapproval/>}/>
       <Route path="/approval/multicommodities-approval" element = {<Multicommodities/>}/>
       <Route path="/approval/roadandtransport" element = {<Roadandtransport/>}/>
       
       
    
      </Routes>
      </HelmetProvider>
      <BottomLink />
      <Footer />
    </div>
  );
}

export default App;
